import logo from '../assets/images/logo.png';

function SessionCheckPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-maroon-100 via-maroon-50 to-maroon-200 p-6">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl shadow-maroon-950/15">
        <img src={logo} alt="Logo" className="mx-auto mb-4 h-16 w-16 object-contain" />
        <h1 className="mb-2 text-2xl font-bold text-maroon-900">Checking Session</h1>
        <p className="text-sm text-maroon-700">Please wait...</p>
      </div>
    </div>
  );
}

export default SessionCheckPage;
